var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeafFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 36,
    viewBox: "0 0 48 48",
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2803 36C15.289 28.6878 15.9584 24.6993 23.9926 21.3755M13.8815 30.694C7.59431 18.5007 17.7534 8.99276 34.1085 12.8833C35.2619 13.1577 36.0548 14.2093 35.997 15.3855C35.4898 25.7469 30.7334 31.619 16.1359 31.9925C15.1955 32.0166 14.3102 31.5254 13.8815 30.694Z",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeafFuture);
export default __webpack_public_path__ + "static/media/icon_leaf_future.466d3c10e083fccd8b22b5853e32cea0.svg";
export { ForwardRef as ReactComponent };